<p-table [value]="paginationResult.entities" [lazy]="true" (onLazyLoad)="loadData($event)"
  [rows]="paginationRequest.pageSize" [totalRecords]="paginationResult.filteredEntities"
  [rowsPerPageOptions]="[10,20,30,40,50]" [paginator]="true" [(selection)]="selectedEntities" [loading]="loading"
  [rowHover]="true" [showCurrentPageReport]="true" dataKey="id"
  currentPageReportTemplate="{first} - {last} {{ 'table.of' | translate }} {totalRecords}" class="custom-table"
  styleClass="p-datatable-striped">

  <!-- #region TABLE TITLE DEFINITION -->
  <ng-template pTemplate="caption">
    @if (showTitle) {
      <div class="d-flex align-items-center justify-content-center text-uppercase mb-5 table-title" [ngClass]="{'custom-title-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-title-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
        {{ 'tableManagement.insurance.insuranceManagement' | translate }}
      </div>
    }
  </ng-template>
  <!-- #endregion TABLE TITE DEFINITION -->

  <!-- #region TABLE COLUMN DEFINITION -->
  <ng-template pTemplate="header">
    <tr [ngClass]="{'custom-header-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-header-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">

      <!-- SELECT -->
      <th class="checkbox-column">
        <div class="d-flex justify-content-center">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </div>
      </th>

      <!-- POLICY NUMBER -->
      <th pSortableColumn="policyNumber">
        <div class="d-flex align-items-center h-100">
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'tableManagement.insurance.policyNumber' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="policyNumber"></p-sortIcon>
            <p-columnFilter field="policyNumber" type="text" matchMode="contains"
              placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
            [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </div>
        </div>
      </th>

      <!-- AGENT -->
      <th pSortableColumn="provider.name">
        <div class="d-flex align-items-center h-100">
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'tableManagement.providers.provider' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="provider.name"></p-sortIcon>
            <p-columnFilter field="provider" type="text" matchMode="contains"
              placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
            [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </div>
        </div>
      </th>

      <!-- COST -->
      @if (canSeeCosts) {
        <th pSortableColumn="cost">
          <div class="d-flex align-items-center h-100">
            <!-- COLUMN TITLE -->
            <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
              {{ 'tableManagement.insurance.cost' | translate }}
            </div>
            <!-- COLUMN SORT && FILTER ICONS -->
            <div class="d-flex align-items-center h-100">
              <p-sortIcon field="cost"></p-sortIcon>
              <p-columnFilter field="cost" type="numeric" matchMode="contains"
                placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
              [showOperator]="false" [showAddButton]="false"></p-columnFilter>
            </div>
          </div>
        </th>
      }

      <!-- OBSERVATIONS -->
      <th pSortableColumn="observations">
        <div class="d-flex align-items-center h-100">
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'drivers.table.observations' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="observations"></p-sortIcon>
            <p-columnFilter field="observations" type="text" matchMode="contains"
              placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
            [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </div>
        </div>
      </th>

      <!-- VEHICLE -->
      @if (!nested) {
        <th pSortableColumn="vehicle">
          <div class="d-flex align-items-center h-100">
            <!-- COLUMN TITLE -->
            <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
              {{ 'tableManagement.vehicle.vehicle' | translate }}
            </div>
            <!-- COLUMN SORT && FILTER ICONS -->
            <div class="d-flex align-items-center h-100">
              <p-sortIcon field="vehicle"></p-sortIcon>
              <p-columnFilter field="vehicle" type="text" matchMode="contains"
                placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
              [showOperator]="false" [showAddButton]="false"></p-columnFilter>
            </div>
          </div>
        </th>
      }

      <!-- INSURANCE TYPE -->
      <th pSortableColumn="insuranceType">
        <div class="d-flex align-items-center h-100">
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'general.type' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="insuranceType"></p-sortIcon>
            <p-columnFilter field="insuranceType" type="text" matchMode="contains"
              placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
            [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </div>
        </div>
      </th>

      <!-- START DATE -->
      <th pSortableColumn="startDate">
        <div class="d-flex align-items-center h-100">

          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'tableManagement.financing.start' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="startDate"></p-sortIcon>
            <p-columnFilter field="startDateFilter" type="date" matchMode="contains"
              placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
            [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </div>

        </div>
      </th>

      <!-- END DATE -->
      <th pSortableColumn="endDate">
        <div class="d-flex align-items-center h-100">

          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'tableManagement.financing.end' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="endDate"></p-sortIcon>
            <p-columnFilter field="endDateFilter" type="date" matchMode="contains"
              placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
            [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </div>

        </div>
      </th>

      <!-- CANCELLATION DATE -->
      <th pSortableColumn="disabledDate">
        <div class="d-flex align-items-center h-100">

          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'tableManagement.accessories.disabledDate' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="disabledDate"></p-sortIcon>
            <p-columnFilter field="disabledDate" type="date" matchMode="contains"
              placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
            [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </div>

        </div>
      </th>

      <!-- DELETE -->
      <th class="button-column"></th>

    </tr>
  </ng-template>
  <!-- #endregion TABLE COLUMN DEFINITION -->

  <!-- #region TABLE BODY -->
  <ng-template pTemplate="body" let-insurance>

    <tr class="p-selectable-row custom-rows" [ngClass]="{'custom-rows-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-rows-medium': authenticationService?.user?.fontSize === 'MEDIUM'}" (dblclick)="editDialog(insurance)">

      <!-- SELECT -->
      <td>
        <div class="d-flex justify-content-center">
          <p-tableCheckbox [value]="insurance"></p-tableCheckbox>
        </div>
      </td>

      <!-- POLCIY NUMBER -->
      <td>
        {{ insurance.policyNumber }}
      </td>

      <!-- AGENT -->
      <td>
        {{ insurance.provider?.name }}
      </td>

      <!-- COST -->
      @if (canSeeCosts) {
        <td>
          {{ insurance.cost }} €
        </td>
      }

      <!-- OBSERVATIONS -->
      <td>
        {{ insurance.observations }}
      </td>

      <!-- VEHICLE -->
      @if (!nested) {
        <td>
          {{ insurance.vehicle.name }}
        </td>
      }

      <!-- INSURANCE TYPE -->
      <td>
        {{ insurance.insuranceType.name }}
      </td>

      <!-- START DATE -->
      <td>
        {{ insurance.startDate | date: 'dd/MM/yyyy' }}
      </td>

      <!-- END DATE -->
      <td>
        {{ insurance.endDate | date: 'dd/MM/yyyy' }}
      </td>

      <td>
        {{ insurance.disabledDate | date: 'dd/MM/yyyy' }}
      </td>

      <!-- DELETE -->
      <td>
        @if (isDisabledGranted) {
          <div>
            <button  type="button" class="btn custom-table-remove-button" (click)="onDeleteInsurance(insurance)">
              <svg-icon
                src="assets/icons/trash.svg"
                class="d-flex flex-wrap custom-table-remove-button-icon"
                [svgStyle]="{ 'height.px': 25, 'width.px': 25 }"
              ></svg-icon>
            </button>
          </div>
        }

      </td>

    </tr>

  </ng-template>
  <!-- #endregion TABLE BODY -->

  <!-- #region TABLE EMPTY MESSAGE -->
  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="colspan" class="p-0">
        <div class="d-flex align-items-center justify-content-center h-100 p-5 custom-empty-message" i18n>
                    {{ 'table.tableEmptyMessage' | translate }}!
                </div>
      </td>
    </tr>
  </ng-template>
  <!-- #endregion TABLE EMPTY MESSAGE -->

  <!-- #region TABLE FOOTER -->
  <ng-template pTemplate="footer">
    <tr>
      <td [attr.colspan]="colspan" class="p-0">
        <div class="d-flex flex-row align-items-center p-3 gap-3">

          <!-- ADD FINE BUTTON -->
          @if (isCreateGranted) {
            <app-table-add-button
              [text]=" 'tableManagement.insurance.insurances' | translate"
            (btnClick)="create()"></app-table-add-button>
          }

          <!-- CHANGE STATUS BUTTON -->
          <app-table-change-status-button (btnClick)="changeStatus()"
          [isDisabled]="selectedEntities.length === 0 || !isDisabledGranted"></app-table-change-status-button>

          <!-- ADD DUPLICATE BUTTON -->
          <app-table-duplicate-button [text]=" 'tableManagement.insurance.insurances' | translate"
            [isDisabled]=" selectedEntities.length !== 1 || !isCreateGranted"
          (btnClick)="duplicate(selectedEntities)"></app-table-duplicate-button>

          <div class="d-flex flex-row " style="margin-left: auto;">
            <!-- UPLOAD DOCUMENT FORM *ngIf="isCreateGranted && showCalculateQuarterly" (no se si tiene que tener algún permiso) -->
            <div  class="buttonTableExcel custom-image-button"
              pTooltip="{{'tableManagement.insurance.insurancedocuments' | translate }}"
              tooltipPosition="top" (click)="showDocumentForm()">
              <svg-icon src="assets/icons/upload-file.svg"
              [svgStyle]="{ 'height.px': 30, 'width.px': 30 }"></svg-icon>
            </div>
            <!-- UPLOAD FILE FORM  -->
            @if (isCreateGranted && showCalculateQuarterly) {
              <div class="buttonTableExcel custom-image-button"
                pTooltip="{{'tableManagement.insurance.insuranceRenewalProcess' | translate }}"
                tooltipPosition="top" (click)="showFileForm()">
                <svg-icon src="assets/icons/upload-file.svg"
                [svgStyle]="{ 'height.px': 30, 'width.px': 30 }"></svg-icon>
              </div>
            }
            <!-- TABLE EXCEL BUTTON -->
            <app-table-excel-button class="buttonTableExcel"
            (btnClick)="exportExcel()"></app-table-excel-button>
            <!-- CALCULATE FORM  -->
            @if (showCalculateQuarterly) {
              <div class="buttonTableExcel custom-image-button"
                pTooltip="{{'tableManagement.insurance.calculateQuarter' | translate }}"
                tooltipPosition="top" (click)="showQuarterlyCalculation()">
                <svg-icon src="assets/icons/upload-file.svg"
                [svgStyle]="{ 'height.px': 30, 'width.px': 30 }"></svg-icon>
              </div>
            }
            <!-- CALCULATE FORM  -->
            <!--<div class="buttonTableExcel custom-image-button "  (click)="showReports()">
            <svg-icon src="assets/icons/upload-file.svg"
            [svgStyle]="{ 'height.px': 30, 'width.px': 30 }"></svg-icon>
          </div>-->
        </div>
      </div>
    </td>
  </tr>
</ng-template>
<!-- #endregion TABLE FOOTER -->

</p-table>

<!-- INSURANCE FORM -->
<app-insurance-form [vehicleId]="vehicle" (return)="refreshList($event,false)"></app-insurance-form>
<!-- INSURANCE UPLOAD FILE FORM -->
<app-upload-documents-form (refreshTable)="refresh()" [renewalType]="renewalType"
[title]="fileFormTitle"></app-upload-documents-form>
<!-- INSURANCE UPLOAD FILE FORM -->
<app-upload-file-form (refreshTable)="refresh()" [renewalType]="renewalType"
[title]="fileFormTitle"></app-upload-file-form>
<app-report></app-report>
<app-insurance-quarterly-calculation></app-insurance-quarterly-calculation>
<p-confirmDialog
  #saveEventDialog
  [header]="'confirm.critic' | translate"
  [message]="'control-panel.delete-dialog.message' | translate"
  class="custom-dialog"
  icon="pi pi-exclamation-triangle"
  key="insurance-list"
  >
  <ng-template pTemplate="footer">
    <!-- REJECT BUTTON -->
    <button (click)="saveEventDialog.onReject()" class="custom-button">
      {{ 'general.no' | translate }}
    </button>
    <!-- ACCEPT BUTTON -->
    <button (click)="saveEventDialog.onAccept()" class="custom-button">
      {{ 'general.yes' | translate }}
    </button>
  </ng-template>
</p-confirmDialog>
